// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__gxtJh","navItem":"BottomNav_navItem__IUC0W"};